module.exports = __webpack_public_path__ + "static/media/click-04.3810eaa7.mp3";